DialogController = App.loadClass 'core::Angular/DialogController'

class exports.EditCompanyLineupsController extends DialogController
    constructor: (@scope, @transitions, @modal, @modalInstance, @service, @company, lineups, crops, seedCompanies) ->
        super @scope, @transitions, @modalInstance

        @scope.absolute_errors = true
        @scope.title = "Edit #{@company.name} Lineups"

        @scope.lineups = lineups.data
        @scope.crops = crops.data
        @scope.seedCompanies = seedCompanies.data
        @scope.selectedCrop = null

        @scope.cropIsEnabled = @cropIsEnabled
        @scope.toggleCrop = @toggleCrop
        @scope.selectCrop = @selectCrop
        @scope.addNewSeedCompany = @addNewSeedCompany
        @scope.seedCompanyIsEnabled = @seedCompanyIsEnabled
        @scope.toggleSeedCompany = @toggleSeedCompany

        @savedSeedCompanies = []

    cropIsEnabled: (crop) =>
        for lineup in @scope.lineups
            return true if lineup.crop.id is crop.id
        false

    toggleCrop: (crop) =>
        # Delete it
        for lineup, i in @scope.lineups
            if lineup.crop.id is crop.id
                @savedSeedCompanies[crop.id] = lineup.seed_companies
                @scope.lineups.splice i, 1

                # Unselect the crop
                if crop.id is @scope.selectedCrop?.id
                    @scope.selectedCrop = null
                return

        # Add it
        @scope.lineups.push
            crop: crop
            seed_companies: @savedSeedCompanies[crop.id] or []

    selectCrop: (crop) =>
        return if not @cropIsEnabled crop
        @scope.selectedCrop = crop

    addNewSeedCompany: () =>
        # open the Seed Company dialog (yoinked from Ratings->Setup)
        dialog = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/admin/new-tools/companies/ng-seed-company-dialog'
            controller: 'Tools.Controllers.SeedCompanyDialogController'

        dialog.result.then (saved_seed_company) =>
            # add the seed company to the list
            @scope.seedCompanies.push(saved_seed_company)

    seedCompanyIsEnabled: (seedCompany) =>
        for lineup in @scope.lineups
            continue if lineup.crop.id isnt @scope.selectedCrop.id

            for lineupSeedCompany in lineup.seed_companies
                return true if lineupSeedCompany.id is seedCompany.id

            return false

    toggleSeedCompany: (seedCompany) =>
        for lineup in @scope.lineups
            if lineup.crop.id is @scope.selectedCrop.id
                # Delete it
                for lineupSeedCompany, i in lineup.seed_companies
                    if lineupSeedCompany.id is seedCompany.id
                        lineup.seed_companies.splice i, 1
                        return

                # Add it
                lineup.seed_companies.push seedCompany
                return

    save: () =>
        @service.saveCompanyLineups(
            @company.id
            @scope.lineups
        ).then (response) =>
            @closeWithAlert(response.data.status)
